import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import './SystemStyles.scss';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import fileDownload from 'js-file-download';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import {
  Alert, Button, Icons, Row,
} from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { FILE_FORMAT, FILE_FORMAT_LIST_NEW } from '../../../configs';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import MultipleSelectInput from '../../../components/fields/SelectInput/MultipleSelectInput';
import {
  getResponseError, getSavedFilter, saveFilter, useUpdatePeriod,
} from '../../../utils/utils';
import notificationDecorator, { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import { getExportData } from '../reducer';
import {
  createExportTask, downloadExportResult, getExportAvailableColumns, getExportTaskStatus,
} from '../actions';
import Timer from '../../../components/base/Loader/Timer';

export default function ExportInterface(props) {
  const {
    page,
    customControl = false,
    exporter = '',
    getValues = () => ({}),
    onClose = () => {},
    buttonText = '',
    variant = 'second',
    className = '',
    selected = [],
    types = FILE_FORMAT_LIST_NEW,
  } = props;
  const {
    loadingCreateExportTask,
    loadingDownloadExportResult,
    loadingGetExportAvailableColumns,
  } = useSelector(getExportData);
  const name = `${page}-export-columns`;
  const [columns, setColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState(getSavedFilter(name) || []);
  const [statusData, setStatus] = useState(null);
  const [showExport, setShowExport] = useState(customControl);
  const [exportId, setExportId] = useState(null);
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const [format, setFormat] = useState(FILE_FORMAT.XLSX);

  const handleChangeColumns = e => {
    saveFilter(e.target.value, name);
    successNotification('Шаблона экспорта', 'Шаблон экспорта сохранен в браузере');
    setSelectedColumns(e.target.value);
  };

  const handleCancel = () => {
    setShowExport(false);
    setExportId(null);
    destroy();
    onClose();
  };

  const handleExport = () => {
    const data = {
      exporter,
      filters: getValues(),
      format,
      columns: selectedColumns,
    };
    if (selected?.length) {
      data.filters.id = selected;
    }
    dispatch(createExportTask(data))
      .then(data => {
        if (data.id) {
          setExportId(data.id);
        } else {
          errorNotification('Экспорт файла', 'Задача не создана');
        }
      })
      .catch(response => errorNotification('Экспорт файла', getResponseError(response)));
  };

  const loadAvailableColumns = () => {
    dispatch(getExportAvailableColumns(exporter))
      .then(data => {
        if (data?.columns?.length) {
          setColumns(data.columns);
          if (!selectedColumns?.length) {
            setSelectedColumns(data.columns);
          }
        } else {
          errorNotification('Загрузка списка полей', 'Не найдены поля экспорта');
        }
      })
      .catch(response => errorNotification('Загрузка списка полей экспорта', getResponseError(response)));
  };

  const loadExportStatus = () => dispatch(getExportTaskStatus(exportId))
    .then(data => {
      setStatus(data || null);
      if (data?.status === 'completed') {
        destroy();
        downloadExport();
      }
      if (data?.status === 'failed') {
        destroy();
      }
    })
    .catch(response => {
      // errorNotification('Экспорт файла', getResponseError(response)); // TODO Раскоментировать когда починят бэк
      downloadExport();
    });

  const downloadExport = () => dispatch(downloadExportResult(exportId))
    .then(data => {
      if (data) {
        handleCancel();
        fileDownload(data, `${formatMessage({ id: `export.name.${exporter}`, defaultMessage: 'Экспорт' })}-${new Date().toLocaleDateString()}.${format}`);
        notificationDecorator({
          title: 'Экспорт файла',
          message: `Экспорт файла ${formatMessage({ id: `file.format.${format}` })}`,
        });
      }
    })
    .catch(response => {
      if (statusData?.status === 'completed') {
        errorNotification('Экспорт файла', getResponseError(response));
      }
    });

  const [setPeriod, destroy] = useUpdatePeriod(loadExportStatus, 0);

  useEffect(() => {
    if (exportId) {
      setPeriod(1);
    } else {
      destroy();
    }
  }, [exportId]);
  useEffect(() => {
    if (showExport) {
      loadAvailableColumns();
    }
  }, [showExport]);

  return (
    <>
      <TimerLoader global loading={loadingCreateExportTask || loadingDownloadExportResult || loadingGetExportAvailableColumns} />
      {!customControl && (
        <Button
          variant={variant}
          onClick={() => setShowExport(true)}
          className={className}
        >
          {buttonText || (
            <Icons
              customIcon
              className="file-download"
              width={24}
              height={24}
              icon="export"
            />
          )}
        </Button>
      )}
      <Dialog
        className="ual-popup-export"
        onClose={() => setShowExport(false)}
        size="xl"
        open={showExport}
      >
        <DialogTitle
          className="hff-title"
          title={(
            <>
              <div className="hff-title-text f2">{formatMessage({ id: `export.name.${exporter}`, defaultMessage: 'Экспорт' })}</div>
              <div className="hff-close-wrapper">
                <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={() => setShowExport(false)} />
              </div>
            </>
          )}
        />
        <DialogContent className="hff-content">
          {!exportId ? (
            <div className="ual-popup-box-action">
              <Row>
                <CustomSelectInput
                  format="text"
                  component={MultipleSelectInput}
                  withLabel
                  variant="material"
                  label="Столбцы для экспорта"
                  multiple
                  inputProps={{
                    value: selectedColumns,
                    onChange: handleChangeColumns,
                  }}
                  options={columns.map(name => ({
                    name: formatMessage({
                      id: `export.column.${exporter}.${name}`,
                      defaultMessage: formatMessage({
                        id: String(name)
                          .replace('representative.', '')
                          .replace('application_vehicle.', '')
                          .replace('application_order_service.', '')
                          .replace('application_carrier.', '')
                          .replace('applicant.', '')
                          .replace('insurance.', ''),
                        defaultMessage: name || ' ',
                      }),
                    }),
                    value: name,
                  }))}
                />
              </Row>
              <div className="ual-popup-box-title">Выберите формат документа для экспорта</div>
              <div className="ual-popup-box-buttons">
                {
                  types.map((item, key) => (
                    <Button
                      className={classNames('ual-popup-box-button', { active: item.value === format })}
                      key={key}
                      variant="link"
                      onClick={() => setFormat(item.value)}
                    >{formatMessage({ id: `file.format.${item.value}` })}
                    </Button>
                  ))
                }
              </div>

            </div>
          ) : (
            <div className="ual-popup-box-action">
              Задача на экспорт создана. Формируется файл экспорта.
              {
                statusData ? (
                  <div>
                    Статус: {statusData?.status_label || ''}. Обработано строк: {statusData?.processed_rows || 0} из {statusData?.total_rows || 0}
                    {statusData?.status === 'failed' ? (
                      <Alert variant="danger" className="mt-3 w-100">
                        {statusData?.error_message}
                      </Alert>
                    ) : null}
                  </div>
                ) : null
              }
              {statusData?.status !== 'failed' ? (
                <div className="ual-loader">
                  <Timer loading text={`Статус: ${statusData?.status_label || ''}. Обработано строк: ${statusData?.processed_rows || 0} из ${statusData?.total_rows || 0}`} />
                </div>
              ) : null}
            </div>
          )}

        </DialogContent>
        <DialogFooter className="hff-footer">
          <Button variant="secondary" onClick={handleCancel}>Отменить</Button>
          {!exportId ? <Button onClick={handleExport}>Экспортировать</Button> : null}
        </DialogFooter>
      </Dialog>
    </>
  );
}
